import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["navigation", "item"];
  static values = {
    activeClass: String
  }

  connect() {
  }

  navigate(event) {
    const item = event.target
    this.itemTargets.forEach((el) => el.classList.remove(this.activeClassValue));
    item.classList.add(this.activeClassValue);

    requestAnimationFrame(() => {
      item.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    });
  }
}
